var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2377 2.50879H6.17937C3.80687 2.50879 2.56104 3.75462 2.56104 6.11629V8.17462C2.56104 10.5363 3.80687 11.7821 6.16854 11.7821H8.22687C10.5885 11.7821 11.8344 10.5363 11.8344 8.17462V6.11629C11.8452 3.75462 10.5994 2.50879 8.2377 2.50879Z",
    fill: "#1996A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6204 2.50879H18.5621C16.2004 2.50879 14.9546 3.75462 14.9546 6.11629V8.17462C14.9546 10.5363 16.2004 11.7821 18.5621 11.7821H20.6204C22.9821 11.7821 24.2279 10.5363 24.2279 8.17462V6.11629C24.2279 3.75462 22.9821 2.50879 20.6204 2.50879Z",
    fill: "#FAB54E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6204 14.8906H18.5621C16.2004 14.8906 14.9546 16.1365 14.9546 18.4981V20.5565C14.9546 22.9181 16.2004 24.164 18.5621 24.164H20.6204C22.9821 24.164 24.2279 22.9181 24.2279 20.5565V18.4981C24.2279 16.1365 22.9821 14.8906 20.6204 14.8906Z",
    fill: "#1996A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2377 14.8906H6.17937C3.80687 14.8906 2.56104 16.1365 2.56104 18.4981V20.5565C2.56104 22.929 3.80687 24.1748 6.16854 24.1748H8.22687C10.5885 24.1748 11.8344 22.929 11.8344 20.5673V18.509C11.8452 16.1365 10.5994 14.8906 8.2377 14.8906Z",
    fill: "#FAB54E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/Overview.ec0c3f7b20f917f9e81203ce815eb8cd.svg";
export { ForwardRef as ReactComponent };